import React, { FC, useState } from 'react';
import { Box, Text, Button, ButtonSize, Icon, IconSize, ButtonAppearance } from '@bechtel/gds';
import { Trans } from '@lingui/macro';
import { IsoPreview } from './iso-preview';
import { IsoDocument } from '@bechtel/types';
import { PdfLoadingButtonStyled, PdfLoadingButtonContainerStyled } from '../styled';

export const IsoContent: FC<IsoDocument> = ({ documentNumber, url }) => {
  const [progress, setProgress]= useState(false);
  return (
    <>
    <Box flexDirection={{ sm: 'column' }} flexGrow={{ sm: 1 }}>
      <Box justifyContent={{ sm: 'space-between' }} flexGrow={{ sm: 1 }} style={{ height: '32px' }} mb={{ sm: '400' }}>
        <Box flexDirection={{ sm: 'column' }}>
          <Box mb={{ sm: '300' }}>
            <Text size="400" color="grey.700">
              <Trans>ISO:</Trans>
            </Text>
          </Box>
          <Text size="400" color="grey.700">
            {documentNumber}
          </Text>
        </Box>
        <Box>
          <Box mr={{ sm: '400' }}>
            <Button size={ButtonSize.SMALL} appearance={ButtonAppearance.SECONDARY} disabled={true}>
              <Icon icon="print" size={IconSize.MEDIUM} fillColor="blue.800" />
            </Button>
          </Box>
          <Box>
            <Button
              size={ButtonSize.SMALL}
              appearance={ButtonAppearance.SECONDARY}
              disabled={!progress}
              onClick={() => {
                if (!url) return;
                window.open(url, '_blank');
              }}
            >
              <Icon icon="expand" size={IconSize.MEDIUM} fillColor="blue.800" />
            </Button>
          </Box>
        </Box>
      </Box> 
      { !progress ? <PdfLoadingButtonContainerStyled ml={{ sm: '400' }}>
     <PdfLoadingButtonStyled
     appearance={ButtonAppearance.SECONDARY}
     size={ButtonSize.SMALL}
     onClick={(e) => {
       setProgress(true);
       e.preventDefault();
     }}
   > 
     <Box ml={{ sm: '100' }} mr={{ sm: '300' }}>
     <Icon icon="rotate" size={IconSize.MEDIUM}  fillColor="blue.800" />
     </Box>
     <Text size={'300'} color={'grey.1000'}>
       <Trans>Load ISO</Trans>
     </Text>
     </PdfLoadingButtonStyled> 
     </PdfLoadingButtonContainerStyled> : 
      <IsoPreview url={url} /> 
   }
    </Box>
   </>
  );
};
